import { ApplicationConstants, ROLES_LIST, USER_ROLES_LIST } from '@shared/models/constants';
import { RouteInfo } from './sidebar.metadata';
export const ROUTES: RouteInfo[] = [
  // {
  //   path: '',
  //   title: 'Main Menu',
  //   iconType: '',
  //   icon: '',
  //   class: '',
  //   groupTitle: true,
  //   badge: '',
  //   badgeClass: '',
  //   role: ['All'],
  //   submenu: [],
  // },

  // Admin Modules

  {
    path: 'dashboard',
    title: 'Dashboard',
    iconType: '',
    icon: '',
    class: '',
    imgSrc: './../../../assets/images/icons/Dashboard.svg',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: [ApplicationConstants.ADMIN_ROLE, ApplicationConstants.PRINTER_ROLE, ApplicationConstants.RESELLER_ROLE, ApplicationConstants.ORGANIZATION_USER_ROLE],
    submenu: [
      // {
      //   path: '/admin/dashboard/main',
      //   title: 'MENUITEMS.DASHBOARD.LIST.DASHBOARD1',
      //   iconType: '',
      //   icon: '',
      //   class: 'ml-menu',
      //   groupTitle: false,
      //   badge: '',
      //   badgeClass: '',
      //   role: [''],
      //   submenu: [],
      // },
    ],
  },
  // Teacher Modules

  {
    path: 'organizations',
    title: 'Organisations',
    iconType: '',
    icon: '',
    class: '',
    imgSrc: './../../../assets/images/icons/Organizations.svg',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: [ApplicationConstants.ADMIN_ROLE, ApplicationConstants.PRINTER_ROLE, ApplicationConstants.RESELLER_ROLE, ApplicationConstants.ORGANIZATION_USER_ROLE],
    submenu: [],
  },

  // Student Modules

  // {
  //   path: 'resellers',
  //   title: 'Resellers',
  //   iconType: 'material-icons-outlined',
  //   icon: 'space_dashboard',
  //   class: '',
  //   groupTitle: false,
  //   badge: '',
  //   badgeClass: '',
  //   role: [ApplicationConstants.ADMIN_ROLE,ApplicationConstants.ADMIN_ROLE],
  //   submenu: [],
  // },
  {
    path: 'orders',
    title: 'Orders',
    iconType: '',
    icon: '',
    class: 'menu-toggle',
    imgSrc: './../../../assets/images/icons/Orders.svg',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: [ApplicationConstants.ADMIN_ROLE, ApplicationConstants.PRINTER_ROLE, ApplicationConstants.RESELLER_ROLE, ApplicationConstants.ORGANIZATION_USER_ROLE],
    submenu: [
      {
        path: 'orders/create',
        title: 'Create Order',
        iconType: 'material-icons-outlined',
        icon: '',
        class: '',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: [ApplicationConstants.ADMIN_ROLE, ApplicationConstants.PRINTER_ROLE, ApplicationConstants.RESELLER_ROLE, ApplicationConstants.ORGANIZATION_USER_ROLE],
        submenu: [],
      },
      {
        path: 'orders/order-wizard',
        title: 'Order Wizard',
        iconType: 'material-icons-outlined',
        icon: '',
        class: '',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: [ApplicationConstants.ADMIN_ROLE, ApplicationConstants.PRINTER_ROLE, ApplicationConstants.RESELLER_ROLE, ApplicationConstants.ORGANIZATION_USER_ROLE],
        submenu: [],
      },
      {
        path: 'orders/manage',
        title: 'Manage Orders',
        iconType: 'material-icons-outlined',
        icon: '',
        class: '',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: [ApplicationConstants.ADMIN_ROLE, ApplicationConstants.PRINTER_ROLE, ApplicationConstants.RESELLER_ROLE, ApplicationConstants.ORGANIZATION_USER_ROLE],
        submenu: [],
      },
      {
        path: 'orders/pending',
        title: 'Pending Orders',
        iconType: 'material-icons-outlined',
        icon: '',
        class: '',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: [ApplicationConstants.ADMIN_ROLE, ApplicationConstants.PRINTER_ROLE, ApplicationConstants.RESELLER_ROLE, ApplicationConstants.ORGANIZATION_USER_ROLE],
        submenu: [],
      },
      {
        path: 'orders/reorder-cards',
        title: 'Reorder Cards',
        iconType: 'material-icons-outlined',
        icon: '',
        class: '',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: [ApplicationConstants.ADMIN_ROLE, ApplicationConstants.PRINTER_ROLE, ApplicationConstants.RESELLER_ROLE, ApplicationConstants.ORGANIZATION_USER_ROLE],
        submenu: [],
      },
      {
        path: 'cardholders/grid',
        title: 'All Cardholders',
        iconType: 'material-icons-outlined',
        icon: 'group',
        class: '',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: [ApplicationConstants.ADMIN_ROLE, ApplicationConstants.PRINTER_ROLE],
        submenu: [],
      },
      {
        path: 'pending-cardholders',
        title: 'Pending Cardholders',
        iconType: 'material-icons-outlined',
        icon: 'group',
        class: '',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: [ApplicationConstants.ADMIN_ROLE, ApplicationConstants.PRINTER_ROLE, ApplicationConstants.RESELLER_ROLE, ApplicationConstants.ORGANIZATION_USER_ROLE],
        submenu: [],
      }
    ],
  },
  {
    path: 'products',
    title: 'Cards',
    iconType: '',
    icon: '',
    class: 'menu-toggle',
    imgSrc: './../../../assets/images/icons/Products.svg',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: [ApplicationConstants.ADMIN_ROLE, ApplicationConstants.PRINTER_ROLE, ApplicationConstants.RESELLER_ROLE, ApplicationConstants.ORGANIZATION_USER_ROLE],
    submenu: [
      {
        path: 'products/create',
        title: 'Create Card',
        iconType: 'material-icons-outlined',
        icon: 'style',
        class: '',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: [ApplicationConstants.ADMIN_ROLE, ApplicationConstants.PRINTER_ROLE],
        submenu: [],
      },
      {
        path: 'products/list',
        title: 'Card List',
        iconType: 'material-icons-outlined',
        icon: 'style',
        class: '',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: [ApplicationConstants.ADMIN_ROLE, ApplicationConstants.PRINTER_ROLE, ApplicationConstants.RESELLER_ROLE],
        submenu: [],
      },
      {
        path: 'form-templates',
        title: 'Card Form Templates',
        iconType: 'material-icons-outlined',
        icon: 'style',
        class: '',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: [ApplicationConstants.ADMIN_ROLE, ApplicationConstants.PRINTER_ROLE, ApplicationConstants.RESELLER_ROLE, ApplicationConstants.ORGANIZATION_USER_ROLE],
        submenu: [],
      },
      {
        path: 'product-request',
        title: 'Card Request',
        iconType: 'material-icons-outlined',
        icon: 'style',
        class: '',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: [ApplicationConstants.ADMIN_ROLE, ApplicationConstants.PRINTER_ROLE, ApplicationConstants.RESELLER_ROLE, ApplicationConstants.ORGANIZATION_USER_ROLE],
        submenu: [],
      }
    ],
  },
  // {
  //   path: 'form-templates',
  //   title: 'Form Templates',
  //   iconType: 'material-icons-outlined',
  //   icon: 'description',
  //   class: '',
  //   groupTitle: false,
  //   badge: '',
  //   badgeClass: '',
  //   role: [ApplicationConstants.ADMIN_ROLE,ApplicationConstants.ADMIN_ROLE],
  //   submenu: [],
  // },
  // {
  //   path: 'cardholders/grid',
  //   title: 'Cardholders',
  //   iconType: '',
  //   icon: '',
  //   class: '',
  //   imgSrc: './../../../assets/images/icons/Organizations.svg',
  //   groupTitle: false,
  //   badge: '',
  //   badgeClass: '',
  //   role: [ApplicationConstants.ADMIN_ROLE, ApplicationConstants.PRINTER_ROLE],
  //   submenu: [],
  // },
  {
    path: 'users',
    title: 'User Management',
    iconType: '',
    icon: '',
    class: 'menu-toggle',
    imgSrc: './../../../assets/images/icons/User Management.svg',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: [ApplicationConstants.ADMIN_ROLE, ApplicationConstants.PRINTER_ROLE, ApplicationConstants.RESELLER_ROLE, ApplicationConstants.ORGANIZATION_USER_ROLE],
    submenu: [{
      path: 'users',
      title: 'Users List',
      iconType: 'material-icons-outlined',
      icon: 'group',
      class: '',
      groupTitle: false,
      badge: '',
      badgeClass: '',
      role: [ApplicationConstants.ADMIN_ROLE, ApplicationConstants.PRINTER_ROLE, ApplicationConstants.RESELLER_ROLE, ApplicationConstants.ORGANIZATION_USER_ROLE],
      submenu: [],
    },
    {
      path: 'app-users',
      title: 'App Users',
      iconType: 'material-icons-outlined',
      icon: 'group',
      class: '',
      groupTitle: false,
      badge: '',
      badgeClass: '',
      role: [ApplicationConstants.ADMIN_ROLE, ApplicationConstants.PRINTER_ROLE],
      submenu: [],
    }, {
      path: 'roles',
      title: 'User Roles',
      iconType: 'material-icons-outlined',
      icon: 'group',
      class: '',
      groupTitle: false,
      badge: '',
      badgeClass: '',
      role: [ApplicationConstants.ADMIN_ROLE, ApplicationConstants.PRINTER_ROLE],
      submenu: [],
    },
      // {
      //   path: 'configurations',
      //   title: 'Manage Configurations',
      //   iconType: 'material-icons-outlined',
      //   icon: 'group',
      //   class: '',
      //   groupTitle: false,
      //   badge: '',
      //   badgeClass: '',
      //   role: [ApplicationConstants.ADMIN_ROLE,ApplicationConstants.ADMIN_ROLE],
      //   submenu: [],
      // }
    ],
  },
  {
    path: 'user-cards',
    title: 'Cards Added on Mobile',
    iconType: '',
    icon: '',
    class: '',
    imgSrc: './../../../assets/images/icons/Cards Added On Mobile.svg',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: [ApplicationConstants.ADMIN_ROLE, ApplicationConstants.PRINTER_ROLE, ApplicationConstants.RESELLER_ROLE, ApplicationConstants.ORGANIZATION_USER_ROLE],
    submenu: [],
  },
  {
    path: 'help-inquiry',
    title: 'Help',
    iconType: '',
    icon: '',
    class: '',
    imgSrc: './../../../assets/images/icons/Help.svg',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: [ApplicationConstants.ADMIN_ROLE, ApplicationConstants.PRINTER_ROLE],
    submenu: [],
  },
  {
    path: 'configurations',
    title: 'Manage Configurations',
    iconType: '',
    icon: '',
    class: '',
    imgSrc: './../../../assets/images/icons/Manage Configarations.svg',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: [ApplicationConstants.ADMIN_ROLE, ApplicationConstants.PRINTER_ROLE],
    submenu: [],
  },
  // {
  //   path: 'pending-cardholders',
  //   title: 'Pending Cardholders',
  //   iconType: 'material-icons-outlined',
  //   icon: 'group',
  //   class: '',
  //   groupTitle: false,
  //   badge: '',
  //   badgeClass: '',
  //   role: [ApplicationConstants.ADMIN_ROLE, ApplicationConstants.RESELLER_ROLE],
  //   submenu: [],
  // }
  // {
  //   path: 'app-users',
  //   title: 'App Users',
  //   iconType: 'material-icons-outlined',
  //   icon: 'group',
  //   class: '',
  //   groupTitle: false,
  //   badge: '',
  //   badgeClass: '',
  //   role: [ApplicationConstants.ADMIN_ROLE,ApplicationConstants.ADMIN_ROLE],
  //   submenu: [],
  // },

  // Common Module


];
